import React from 'react';
import Header from './../inc/Header';
import Footer from './../inc/Footer';
import Loader from './../inc/Loader';
import Menu from './../inc/Menu';
import MenuToggleBtn from './../inc/MenuToggleBtn';

import Values from './../About/Values';

import { fetchMenu } from "./../../actions/menuActionCreators";
import { fetchPage } from "./../../actions/pageActionCreators";
import ScrollToTop from './../inc/ScrollToTop';
import { fetchOptions } from "./../../actions/optionActionCreators";

const page_id = '10';

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageLoading: true
		}
	}

	componentWillMount(){
		let before = performance.now();
		let _this = this;
		Promise.all([
			this.props.dispatch(fetchOptions()),
			this.props.dispatch(fetchMenu('menu')),
			this.props.dispatch(fetchPage(page_id))
		]).then(() => {
			let after = performance.now();
			let diff = after-before;
			let media_length = process.env.REACT_APP_ANIMATION_DURATION;
			if(diff < media_length){
				setTimeout(() => {
					_this.setState({
						pageLoading: false
					})
				},(media_length - diff))
			}else{
				_this.setState({
					pageLoading: false
				})
			}
			
		});
	}

	render() {
		let _this = this;
		let { menu } = this.props.menu;
		return (
			<React.Fragment>
				{this.state.pageLoading &&
					<Loader />
				} 
				<ScrollToTop />
				<Header {..._this.props}/>
				<main className="mole__about values" >
					<Values {..._this.props} page_id={page_id}/>
				</main>
				{!this.state.pageLoading &&
					<Menu {..._this.props}/>
				}
				<Footer {..._this.props}/>
			</React.Fragment>
		);
	}
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Values/_index.js